import * as React from "react";
import EmailIcon from "./icons/Opened-envelope-icon.svg";
import BlueArrowRightIcon from "./icons/right-arrow-icon.png";
import { Link } from "gatsby-link";

type EmailProps = {
  iconSrc?: string;
};

const Email: React.FC<EmailProps> = ({ iconSrc = EmailIcon }) => (
  <div className="text-center my-104 gap-1 px-1">
    <img
      src={iconSrc}
      loading="eager"
      width={174}
      alt="Opened envelope icon"
      className="block mx-auto mb-24"
    />
    <p className="h2 mb-24 text-royal-blue">
      Stay up to date on the latest <br className="desktop" />
      from NUPLAZID
    </p>

    <Link
      to="/sign-up-for-updates"
      className="m-auto bg-royal-blue primary-btn color-white"
      aria-label="Get updates about the latest from NUPLAZID"
    >
      Get updates{" "}
      <img
        src={BlueArrowRightIcon}
        width={28}
        height={28}
        className="blue-arrow-right-icon mr-0 m-auto"
        alt="Right arrow icon"
      />
    </Link>
  </div>
);

export default Email;
